import { render } from "./EditBuyersModal.vue?vue&type=template&id=78db4db3&scoped=true&ts=true&lang=pug"
import script from "./EditBuyersModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditBuyersModal.vue?vue&type=script&lang=ts&setup=true"

import "./EditBuyersModal.vue?vue&type=style&index=0&id=78db4db3&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78db4db3"]])

export default __exports__